import React, { Component } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta, RatatoskRequest, getLocalizedLabel } from '../../common'
import { Button, Checkbox, Container, Dimmer, Dropdown, Grid, Header, Icon, Input, Label, Loader, Message, Modal, Progress, Segment } from 'semantic-ui-react'
import FileSelect from '../FileSelect'
import CNCDictCandidatesItem from './CNCDictCandidatesItem'
import CNCDictCandidatesExamples from './CNCDictCandidatesExamples'
import { addForms } from './CNCDictSublemma'
import { Md5 } from 'ts-md5'

interface CNCDictAddSublemmasProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance
}

interface CNCDictAddSublemmasState {
    loadingPath: boolean,
    patternList: any[],
    sublemmas: any[],
    loading: boolean,
    errorMsg: string,
    initialized: boolean,
    quickSearch: string
}

const ROOT_TYPE = ':cncdict'
const ROOT_PATH = ROOT_TYPE.replaceAll(':','/').replace(/^\//, '_/')

class CNCDictAddSublemmas extends Component<CNCDictAddSublemmasProps, CNCDictAddSublemmasState> {

    state = {
        loadingPath: false,
        patternList: [],
        sublemmas: [] as any[],
        loading: false,
        errorMsg: '',
        initialized: false,
        quickSearch: ''
    }

    loadPatternList() {
        const { t } = this.props
        let request: RatatoskRequest = {
            query: {
                'type': ':cncdict:pattern'
            },
            page: { from: 0, size: 10000 },
            feats: [
                ":form:cncdict:base_ending",
                ":form:cncdict:base_tag",
                ":form:cncdict:base_constraints",
                ":form:cncdict:ending"
            ]
        }
        this.setState({loading: true})
        const url = 'cunits/_view'
        this.props.http.post(url, request)
            .then(response => {
                const list = response.data.data.sort(i => i._name)
                this.setState({patternList: list, errorMsg: '', loading: false})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false})
                } else {
                    console.log(err)
                    this.setState({errorMsg: t('Unknown error'), loading: false})
                }
            })
    }

    loadPath(path) {
        const { t, meta } = this.props
        this.setState({loadingPath: true})
        const url = 'files/'+path
        this.props.http.get(url)
            .then(response => {
                const data = response.data.data
                if (typeof(data)==='string') {
                    const sublemmas = data.split('\n').filter((l: string) => l.trim()).map(sublemmaSpec => {
                        const [sublemma, spec] = sublemmaSpec.split('_')
                        return({
                            key: window.crypto.randomUUID(),
                            sublemma: [sublemma],
                            pattern: [''],
                            patternFilter: [spec],
                            fromFile: true,
                            created: null,
                            forms: []
                        })
                    })
                    this.setState({sublemmas: sublemmas, errorMsg: '', loadingPath: false, initialized: true})
                } else
                    this.setState({sublemmas: [], errorMsg: '', loadingPath: false, initialized: true})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loadingPath: false, sublemmas: []})
                } else {
                    console.log(err)
                    this.setState({errorMsg: t('Unknown error'), loadingPath: false, sublemmas: []})
                }
            })
    }

    async componentDidMount(): Promise<void> {
        this.loadPatternList()
        if (this.props.match.params[0])
            this.loadPath(this.props.match.params[0])
    }

    componentDidUpdate(prevProps: Readonly<CNCDictAddSublemmasProps>, prevState: Readonly<CNCDictAddSublemmasState>, snapshot?: any): void {
        const { loadingPath } = this.state
        if (!loadingPath) {
            const path = this.props.match.params[0]
            if (path!==prevProps.match.params[0]) {
                if (path)
                    this.loadPath(path)
                else
                    this.setState({sublemmas: []})
            }
        }
    }


    render() {
        const { i18n, t, meta, history } = this.props
        const { sublemmas, patternList, loading, quickSearch } = this.state

        const changePath = (newtype: string) => {
            if (newtype) {
                history.push('/comp/cncdict/addsublemmas/'+newtype.replaceAll(':', '/').replace(/^\//, '_/'))
            } else {
                history.push('/comp/cncdict/addsublemmas/')
            }
        }

        const setSubLemma = (i: number, subi: number, value: string) => {
            sublemmas[i].sublemma[subi] = value
            this.setState({sublemmas: sublemmas})
        }

        const setPattern = (i: number, subi: number, value: string) => {
            sublemmas[i].pattern[subi] = value
            this.setState({sublemmas: sublemmas})
        }

        const setCreated = (i: number, value = true) => {
            sublemmas[i].created = value
            this.setState({sublemmas: sublemmas})
        }

        const addPattern = () => {
            sublemmas.unshift({
                key: window.crypto.randomUUID(),
                sublemma: [''],
                pattern: [''],
                created: null,
                forms: []
            })
            this.setState({sublemmas: sublemmas})
        }

        const openQuickSearch = () => {
            window.open(location.pathname.replace(/\/comp\/cncdict\/addsublemmas\/.*$/,"")+'/search/_cncdict_dict/'+quickSearch, '_blank')
        }

        const initialType = this.props.match.params[0].replaceAll('/',':').replace(/^_:/, ':') || ROOT_TYPE

        return(
            <Container>
            <Grid>
                {this.state.errorMsg ?
                (
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                        </Grid.Column>
                    </Grid.Row>
                )
                : null }
                <Grid.Row>
                    <Grid.Column width={16}>
                        <FileSelect {...this.props} rootType={ROOT_TYPE} setSelected={changePath}
                            initialType={initialType}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={6}>
                        <Button type="button" color="blue" icon="plus" onClick={() => addPattern()} title={t('Add')}/>
                    </Grid.Column>
                    <Grid.Column width={4} textAlign='center'>
                        <Input fluid value={quickSearch} placeholder={t('search form')}
                            onChange={(e, {value}) => this.setState({quickSearch: value})} onKeyDown={(e) => { if (e.key==='Enter') openQuickSearch() }}
                            action={{icon: 'search', onClick: openQuickSearch , title: t('Form search in new tab')}} labelPosition='right'/>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign='right'>
                    </Grid.Column>
                </Grid.Row>
                { sublemmas.map((p: any, i: number) => (
                    <CNCDictCandidatesItem {...this.props} key={p.key} sublemmas={sublemmas} itemIdx={i} patternList={patternList} setCreated={setCreated}
                        setSubLemma={setSubLemma} setPattern={setPattern}/>
                ))}
            </Grid>
            </Container>
        )
    }
}

export default withTranslation()(CNCDictAddSublemmas)